import { apiClient } from "../api/apiclient";

export const createStory = async (formData, token) => {
  return apiClient.post("/stories", formData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};


export const updateStoryPoints = (id, points, token) =>
  apiClient.put(`/stories/${id}/story-points`, points, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },

  });


export const getAllTeams = (token) =>
  apiClient.get("/teams", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllSprints = (token) =>
  apiClient.get("/sprints", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllUsers = (token) =>
  apiClient.get("/allusers", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getAllStory = (token) =>
  apiClient.get("/stories", {
    headers: { Authorization: `Bearer ${token}` },
  });

  export const getEmployeeStories = (token) =>
  apiClient.get("/stories/my-stories", {
    headers: { Authorization: `Bearer ${token}` },
  });

// GET most recent comment on any story assigned to me (for dashboard recent activity)
export const getMyRecentStoryComment = (token) =>
  apiClient.get("/stories/my-recent-comment", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateSubTask = (id, updatedSubTask, token) =>
  apiClient.put(`/subtasks/${id}`, updatedSubTask, {
    headers: { Authorization: `Bearer ${token}` },
  });
export const deleteSubTask = (id, token) =>
  apiClient.delete(`/subtasks/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateStory = (id, formData, token) => {
  return apiClient.put(`/stories/${id}`, formData, {

    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
    },
  });
};



export const sendForRTS = (id, token) =>
  apiClient.post(
    `/stories/${id}/send-for-rts`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
export const acceptRTS = (id, token) =>
  apiClient.post(
    `/stories/${id}/accept-rts`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );

// export const downloadAttachment = async (filename, token) => {
//   return apiClient.get(`/stories/files/${filename}`, {
//     responseType: "blob",
//     headers: { Authorization: `Bearer ${token}` },
//   });
// };
export const downloadAttachment = (filename, token) => {
  return apiClient.get(`/stories/files/${filename}`, {
    responseType: "blob",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
export const updateStoryStatus = (id, status, token) =>
  apiClient.patch(`/stories/${id}/status`, { status }, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

